/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} No_New_NotificationsInputs */

const en_no_new_notifications = /** @type {(inputs: No_New_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No new notifications`)
};

const id_no_new_notifications = /** @type {(inputs: No_New_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tidak ada notifikasi baru`)
};

/** @type {(inputs: No_New_NotificationsInputs) => LocalizedString} */
const es_no_new_notifications = en_no_new_notifications;

/** @type {(inputs: No_New_NotificationsInputs) => LocalizedString} */
const fr_no_new_notifications = en_no_new_notifications;

/** @type {(inputs: No_New_NotificationsInputs) => LocalizedString} */
const de_no_new_notifications = en_no_new_notifications;

/** @type {(inputs: No_New_NotificationsInputs) => LocalizedString} */
const ja_no_new_notifications = en_no_new_notifications;

/** @type {(inputs: No_New_NotificationsInputs) => LocalizedString} */
const zh_no_new_notifications = en_no_new_notifications;

/** @type {(inputs: No_New_NotificationsInputs) => LocalizedString} */
const ar_no_new_notifications = en_no_new_notifications;

/** @type {(inputs: No_New_NotificationsInputs) => LocalizedString} */
const it_no_new_notifications = en_no_new_notifications;

/** @type {(inputs: No_New_NotificationsInputs) => LocalizedString} */
const ru_no_new_notifications = en_no_new_notifications;

/** @type {(inputs: No_New_NotificationsInputs) => LocalizedString} */
const pt_no_new_notifications = en_no_new_notifications;

/** @type {(inputs: No_New_NotificationsInputs) => LocalizedString} */
const ko_no_new_notifications = en_no_new_notifications;

/**
* | output |
* | --- |
* | "No new notifications" |
*
* @param {No_New_NotificationsInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const no_new_notifications = /** @type {((inputs?: No_New_NotificationsInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<No_New_NotificationsInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_no_new_notifications(inputs)
	if (locale === "es") return es_no_new_notifications(inputs)
	if (locale === "fr") return fr_no_new_notifications(inputs)
	if (locale === "de") return de_no_new_notifications(inputs)
	if (locale === "ja") return ja_no_new_notifications(inputs)
	if (locale === "zh") return zh_no_new_notifications(inputs)
	if (locale === "ar") return ar_no_new_notifications(inputs)
	if (locale === "id") return id_no_new_notifications(inputs)
	if (locale === "it") return it_no_new_notifications(inputs)
	if (locale === "ru") return ru_no_new_notifications(inputs)
	if (locale === "pt") return pt_no_new_notifications(inputs)
	return ko_no_new_notifications(inputs)
});